'use es6';

import Client from 'AdsUI/data/Client';
import PortalIdParser from 'PortalIdParser'; // This key value was set before the widget experiment

export const ONBOARDING_TOUR_COMPLETE_KEY = 'ads.shepherdTourComplete';
export const HIDE_COUPON_BANNER_KEY = 'ads.hideCouponBanner';
export const ONBOARDING_DEMO_STEP = 'ads.lastOnboardingDemoStep';
export const SEEN_COUPON_BADGE_KEY = 'ads.seenCouponBadge';
export const SEEN_EDUCATION_COLUMNS_KEY = 'ads.seenEducationColumns';
export const SEEN_MARKETING_CONTACTS_TOGGLE = 'ads.seenMarketingContactsToggle';
export const SEEN_MARKETING_CONTACTS_CHECKBOX = 'ads.seenMarketingContactsCheckbox';
export const SEEN_FACEBOOK_CAPI_LCS_MODAL = 'ads.seenFacebookCapiLcsModal';
export const SEEN_FACEBOOK_CAPI_EVENT_BANNER = 'ads.seenFacebookCapiEventBanner';
export const SEEN_ACCOUNT_LIMIT_INCREASE_ALERT = 'ads.seenAccountLimitIncreaseAlert';
const ALL_KEYS = [ONBOARDING_TOUR_COMPLETE_KEY, HIDE_COUPON_BANNER_KEY, ONBOARDING_DEMO_STEP, SEEN_COUPON_BADGE_KEY, SEEN_EDUCATION_COLUMNS_KEY, SEEN_MARKETING_CONTACTS_TOGGLE, SEEN_MARKETING_CONTACTS_CHECKBOX, SEEN_FACEBOOK_CAPI_LCS_MODAL, SEEN_FACEBOOK_CAPI_EVENT_BANNER, SEEN_ACCOUNT_LIMIT_INCREASE_ALERT];
const baseUrl = 'users/v1/app/attributes';
export const getAdsUserAttributes = userId => {
  return Client.apiRequest(`${baseUrl}/bulk-get`, {
    type: 'PUT',
    data: {
      userId,
      keys: ALL_KEYS.map(key => `${key}.${PortalIdParser.get()}`)
    }
  });
};
export const setOnboardingTourStatusForUser = userId => {
  return Client.apiRequest(baseUrl, {
    type: 'POST',
    data: {
      userId,
      key: `${ONBOARDING_TOUR_COMPLETE_KEY}.${PortalIdParser.get()}`,
      value: true
    }
  });
};
export const getCouponBannerHiddenForUser = userId => {
  return Client.apiRequest(baseUrl, {
    query: {
      'user-id': userId,
      key: `${HIDE_COUPON_BANNER_KEY}.${PortalIdParser.get()}`
    }
  });
};
export const setCouponBannerHiddenForUser = userId => {
  return Client.apiRequest(baseUrl, {
    type: 'POST',
    data: {
      userId,
      key: `${HIDE_COUPON_BANNER_KEY}.${PortalIdParser.get()}`,
      value: true
    }
  });
};
export const setSeenCouponBadgeForUser = userId => {
  return Client.apiRequest(baseUrl, {
    type: 'POST',
    data: {
      userId,
      key: `${SEEN_COUPON_BADGE_KEY}.${PortalIdParser.get()}`,
      value: true
    }
  });
};
export const setSeenEducationColumnsForUser = (userId, columns) => {
  return Client.apiRequest(baseUrl, {
    type: 'POST',
    data: {
      userId,
      key: `${SEEN_EDUCATION_COLUMNS_KEY}.${PortalIdParser.get()}`,
      value: JSON.stringify(columns)
    }
  });
};
export const setSeenMarketingContactsToggleForUser = userId => {
  return Client.apiRequest(baseUrl, {
    type: 'POST',
    data: {
      userId,
      key: `${SEEN_MARKETING_CONTACTS_TOGGLE}.${PortalIdParser.get()}`,
      value: true
    }
  });
};
export const setSeenMarketingContactsCheckboxForUser = userId => {
  return Client.apiRequest(baseUrl, {
    type: 'POST',
    data: {
      userId,
      key: `${SEEN_MARKETING_CONTACTS_CHECKBOX}.${PortalIdParser.get()}`,
      value: true
    }
  });
};
/**
 * Set the given user attribute to the value.
 * @param attribute The attribute key/name (e.g., "ads.shepherdTourComplete")
 * @param userId The user's ID
 * @param value The value to set the attribute to
 */

export const setUserAttribute = (attribute, userId, value) => {
  return Client.apiRequest(baseUrl, {
    type: 'POST',
    data: {
      userId,
      key: `${attribute}.${PortalIdParser.get()}`,
      value
    }
  });
};